<template>
    <b-container class="mt-5">
        <b-row class="justify-content-center">
            <b-col cols="12" md="8" lg="6">
                <b-button v-if="showTable" variant="primary" class="mb-3" block @click="back">
                    Back
                </b-button>
            </b-col>
        </b-row>

        <b-row class="justify-content-center">
            <b-col cols="12" md="8" lg="6" v-if="!showTable">
                <b-card header="Select Date Range" header-tag="h4" class="shadow">
                    <b-form>
                        <!-- Date From -->
                        <b-form-group label="Date From" label-for="date-from">
                            <b-form-datepicker id="date-from" v-model="dateFrom" placeholder="Select start date"
                                :max="dateTo"></b-form-datepicker>
                        </b-form-group>

                        <!-- Date To -->
                        <b-form-group label="Date To" label-for="date-to">
                            <b-form-datepicker id="date-to" v-model="dateTo" placeholder="Select end date"
                                :min="dateFrom"></b-form-datepicker>
                        </b-form-group>

                        <!-- Submit Button -->
                        <b-button variant="primary" class="mt-3" block @click="submitDates">
                            Submit
                        </b-button>
                    </b-form>
                </b-card>
            </b-col>

            <b-col cols="12" v-if="showTable">
                <b-card :header="tdsHeader" header-tag="h4" class="shadow">

                    <b-button variant="success" class="mb-3" @click="exportToCSV">
                        Export to CSV
                    </b-button>

                    <b-table striped hover responsive="sm" :items="paginatedItems" :fields="tableFields" :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc">
                        <template #cell(link)="data">
                            <feather-icon icon="EyeIcon" size="16" class="mr-50" @click="viewContent(data.item)" />
                        </template>
                    </b-table>


                    <b-pagination v-model="currentPage" :total-rows="tableData.length" :per-page="perPage"
                        aria-controls="cashbook-table" class="mt-3 justify-content-center"></b-pagination>
                </b-card>
            </b-col>

        </b-row>
    </b-container>
</template>

<script>
import Swal from "sweetalert2";
import {
    BContainer,
    BRow,
    BCol,
    BCard,
    BForm,
    BFormGroup,
    BFormDatepicker,
    BButton,
    BTable,
    BPagination,
    BIcon,
    BDropdown
} from "bootstrap-vue";
import { mapActions } from "vuex";
import { format } from "date-fns";
export default {
    components: {
        BContainer,
        BRow,
        BCol,
        BCard,
        BForm,
        BFormGroup,
        BFormDatepicker,
        BButton,
        BTable,
        BPagination,
        BIcon,
        BDropdown
    },
    data() {
        return {
            dateFrom: null,
            dateTo: null,
            showTable: false,
            tableData: [],
            currentPage: 1,
            perPage: 5,
            sortBy: "date", // Default sorting column
    sortDesc: true, // Default ascending order
    tableFields: [
      { key: "type", label: "Type", sortable: true },
      { key: "amount", label: "Amount", sortable: true },
      { key: "description", label: "Description", sortable: true },
    //   { key: "date", label: "Date", sortable: true },
    {
        // key: 'formattedDate',
        // label: 'Date',
        // sortable: true,
        // sortKey: 'date' 
        key: 'date',
  label: 'Date',
  sortable: true,
  formatter: (value) => value ? format(value, 'dd-MM-yyyy') : '-' 
    },
      { key: "paymentType", label: "Payment Type", sortable: true },
      { key: "category", label: "Category", sortable: true },
      { key: "link", label: "View" }
    ],
        };
    },
    computed: {
        tdsHeader() {
            return this.dateFrom && this.dateTo
                ? `Cashbook Data from: ${this.dateFrom} to: ${this.dateTo}`
                : "Cashbook Data";
        },

        
        formattedTableData() {

            return this.tableData.map(item => {
        const rawDate = item.date ? new Date(item.date) : null;
        return {
            type: item.type ?? "-",
            amount: item.amount ?? "-",
            description: item.description && item.description.trim() !== "" ? item.description : "-",
            date: rawDate, 
            // formattedDate: rawDate ? format(rawDate, "dd-MM-yyyy") : "-", 
            paymentType: item.paymentType ?? "-",
            category: item.category ?? "-",
            transactionId: item.transactionId ?? null,
        };
    });
        },

        sortedTableData() {
  const data = [...this.formattedTableData]; // clone array

  if (this.sortBy) {
    data.sort((a, b) => {
      const aVal = a[this.sortBy];
      const bVal = b[this.sortBy];

      // Handle dates, strings, numbers
      if (aVal instanceof Date && bVal instanceof Date) {
        return this.sortDesc
          ? bVal - aVal
          : aVal - bVal;
      }

      // Fallback to string comparison
      if (typeof aVal === 'string' && typeof bVal === 'string') {
        return this.sortDesc
          ? bVal.localeCompare(aVal)
          : aVal.localeCompare(bVal);
      }

      // Numbers or other
      return this.sortDesc
        ? (bVal ?? 0) - (aVal ?? 0)
        : (aVal ?? 0) - (bVal ?? 0);
    });
  }

  return data;
},

        paginatedItems() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.sortedTableData.slice(start, end);
        }
    },
    methods: {
        ...mapActions("reportModule", ["getCashBookReportAction"]),

        async submitDates() {
            if (!this.dateFrom || !this.dateTo) {
                Swal.fire({
                    title: "Error",
                    text: "Please select both dates.",
                    icon: "error",
                    confirmButtonText: "OK",
                });
                return;
            }

            try {
                Swal.fire({
                    title: "Fetching Cash Book data...",
                    text: "Please wait...",
                    didOpen: () => {
                        Swal.showLoading();
                    },
                    allowOutsideClick: false,
                });

                const payload = {
                    dateFrom: this.dateFrom, 
                    dateTo: this.dateTo
                };

                console.log("API Request Payload:", payload);

                // Call API via Vuex action
                const response = await this.getCashBookReportAction(payload);
                Swal.close();
                console.log("API Response:", response);

                if (response && response.length > 0) {
                    this.tableData = response;
                    this.showTable = true;
                } else {
                    Swal.fire({
                        title: "No Data",
                        text: "No data available for the selected period.",
                        icon: "warning",
                        confirmButtonText: "OK"
                    });
                }
            } catch (error) {
                console.error("Error fetching Cash Book data:", error);

                if (error.response && error.response.data && error.response.data.errors) {
                    const errors = error.response.data.errors;
                    let errorMessage = "Validation errors occurred:\n";

                    for (const key in errors) {
                        if (errors.hasOwnProperty(key)) {
                            errorMessage += `${key}: ${errors[key].join(", ")}\n`;
                        }
                    }

                    Swal.fire({
                        title: "Validation Error",
                        text: errorMessage,
                        icon: "error",
                        confirmButtonText: "OK"
                    });
                } else {
                    Swal.fire({
                        title: "Error",
                        text: "Failed to fetch Cash Book data. Please try again.",
                        icon: "error",
                        confirmButtonText: "OK"
                    });
                }
            }
        },
        back() {
            this.showTable = false;
        },

        exportToCSV() {

            const headers = this.tableFields.map(field => field.label).join(",");
            const rows = this.formattedTableData.map(item =>
                this.tableFields.map(field => item[field.key] ?? "-").join(",")
            );

            const csvContent = [headers, ...rows].join("\n");


            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            const currentDate = new Date().toISOString().slice(0, 10);
            link.href = URL.createObjectURL(blob);
            link.download = `Cashbook_Data_${currentDate}.csv`;

            // Trigger the download
            link.click();
            URL.revokeObjectURL(link.href);
        },
        viewContent(item) {
            if (!item.transactionId) {
                Swal.fire({
                    title: "Error",
                    text: "Transaction ID is missing.",
                    icon: "error",
                    confirmButtonText: "OK"
                });
                return;
            }
            let url = "";
            // Example logic to redirect based on category
            if (item.category === "PURCHASE INVOICE") {
                url = `/purchaseinvoice/view/${item.transactionId}`;
            } else if (item.category === "SALES") {
                url = `/invoice/view/${item.transactionId}`;
            } else {
                Swal.fire({
                    title: "Error",
                    text: "Unsupported category or missing data.",
                    icon: "error",
                    confirmButtonText: "OK"
                });
                return;
            }

            window.open(url, "_blank");
        },
    },
};
</script>

<style scoped>
.b-card {
    border-radius: 10px;
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
}
</style>
